import { useParams } from 'react-router-dom';

import { KeywordRules } from '../components/KeywordRules/KeywordRules';
import { KeywordStats } from '../components/KeywordStats/KeywordStats';

import { SectionDivider } from '@/components/Layout/SectionDivider';
import { UrlPlatform, urlToDomainPlatform } from '@/features/pages';

type Props = {
  platform: UrlPlatform;
};

export const KeywordRulesPage = ({ platform }: Props) => {
  const { id = '' } = useParams<{ id: string }>();
  const chunkPlatform = urlToDomainPlatform(platform);

  return (
    <div>
      <SectionDivider label="Rules" />
      <KeywordRules pageId={id} platform={chunkPlatform} />
      <SectionDivider label="Stats" />
      <KeywordStats pageId={id} />
    </div>
  );
};
